import React from "react";
import styled from "styled-components";
import { GitHub, Language  } from "@material-ui/icons";


function Menu({ menuItem }) {
  return (
    <MenuItemStyled>
      {menuItem.map(({ id, image, link1, link2, title, text }, i) => (
        <div className="grid-item" key={id}>
          <div className="portfolio-content">
            <div className="portfolio-image">
              <img src={image} alt="portfolioImage" />
              <ul>
                <li>
                  <a href={link1} target="_blank" rel="noreferrer">
                    <GitHub />
                  </a>
                  <a href={link2} target="_blank" rel="noreferrer">
                    <Language />
                  </a>
                </li>
              </ul>
            </div>
            <h6>{title}</h6>
            <p>{text}</p>
          </div>
        </div>
      ))}
    </MenuItemStyled>
  );
}

const MenuItemStyled = styled.div`
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2rem;
  @media screen and (max-width: 920px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 670px) {
    grid-template-columns: repeat(1, 1fr);
  }
  .grid-item {
    .portfolio-content {
      display: block;
      position: relative;
      overflow: hidden;
      h6 {
        font-size: 1.5rem;
      }
      img {
        width: 100%;
        height: 30vh;
        object-fit: cover;
      }
      ul {
        transform: translateY(-600px);
        transition: all 0.4s ease-in-out;
        position: absolute;
        left: 50%;
        top: 40%;
        opacity: 0;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1rem;
          border-radius: 50%;
          width: 3rem;
          height: 3rem;
          margin: 0 0.5rem;
          transition: all 0.4s ease-in-out;
          a {
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.4s ease-in-out;
            &:last-child{
              margin-left: 0.5rem;
            }
          }
        }
      }
      .portfolio-image {
        &::before {
          content: "";
          position: absolute;
          left: 2%;
          top: 4%;
          height: 0;
          width: 0;
          transition: all 0.4s ease-in-out;
        }
      }
      .portfolio-image:hover {
        ul {
          transform: translateY(0);
          transform: translate(-50%, -50%);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.4s ease-in-out;
          opacity: 1;
          li {
            transition: all 0.4s ease-in-out;
            a {
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.4s ease-in-out;
            }
          }
          li:hover {
            svg {
              color: var(--white-color);
              &:hover {
                color: var(--primary-color);
              }
            }
          }
          svg {
            font-size: 2rem;
          }
        }
        &::before {
          height: calc(100% - 32%);
          width: calc(100% - 4%);
          background-color: white;
          opacity: 0.9;
          transform-origin: left;

          transition: all 0.4s ease-in-out;
        }
      }
    }
  }
`;

export default Menu;
